import { PRODUCT_CODE_TYPES } from 'constants/payments';
import { SubscriptionProductCodeTypes } from 'types/product';

const isMainSubscription = (productType?: SubscriptionProductCodeTypes) =>
    Boolean(
        productType &&
            [PRODUCT_CODE_TYPES.MAIN_SUBSCRIPTION, PRODUCT_CODE_TYPES.UPGRADE_SUBSCRIPTION].includes(productType)
    );

export default isMainSubscription;
